import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
/* REDUX */
import { connect } from 'react-redux'
import { loadLikes, loadSaves, likeReport, saveReport } from '../../actions/attributes'

class AttrLiked extends React.Component {
	constructor(props) {
		super(props)
		this.state = { 
			userLiked: false
		}
		this.handleLike = this.handleLike.bind(this)
	}
	
	componentWillMount() {
		this.setState({
			userLiked: this.props.userLiked
		})
	}
	
	componentWillReceiveProps(nextProps) {
		this.setState({
			userLiked: nextProps.userLiked
		})
	}
	
	handleLike(e) {
		e.preventDefault()
		const { authenticated, onLogin, likeReport, report_id } = this.props
		if (!authenticated) {
			onLogin()
			return
		}
		if (this.state.userLiked) {
			likeReport(report_id, 'unlike')
		} else {
			likeReport(report_id, 'like')
		}
	}
	
	render() {
		return (
			<button type="button" className={ this.state.userLiked ? "attr liked" : "attr" } onClick={ this.handleLike }>
				<span className="icon"><svg viewBox="0 0 576 512"><path d="M329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.9 0 60-40 41.6-72l-240-416z"></path></svg></span><span className="label">{ this.props.likesCount }</span>
			</button>
		)
	}
}

class AttrSaved extends React.Component {
	constructor(props) {
		super(props)
		this.state = { 
			userSaved: false
		}
		this.handleSave = this.handleSave.bind(this)
	}
	
	componentWillMount() {
		this.setState({
			userSaved: this.props.userSaved
		})
	}
	
	componentWillReceiveProps(nextProps) {
		this.setState({
			userSaved: nextProps.userSaved
		})
	}
	
	handleSave(e) {
		e.preventDefault()
		const { authenticated, onLogin, saveReport, report_id } = this.props
		if (!authenticated) {
			onLogin()
			return
		}
		if (this.state.userSaved) {
			saveReport(report_id, 'unsave')
		} else {
			saveReport(report_id, 'save')
		}
	}
	
	render() {
		return (
			<button type="button" className={ this.state.userSaved ? "attr attr-o saved" : "attr attr-o" } onClick={ this.handleSave }>
				<span className="icon"><svg viewBox="0 0 448 512"><path d="M448 294.2v-76.4c0-13.3-10.7-24-24-24H286.2V56c0-13.3-10.7-24-24-24h-76.4c-13.3 0-24 10.7-24 24v137.8H24c-13.3 0-24 10.7-24 24v76.4c0 13.3 10.7 24 24 24h137.8V456c0 13.3 10.7 24 24 24h76.4c13.3 0 24-10.7 24-24V318.2H424c13.3 0 24-10.7 24-24z"></path></svg></span><span className="label">{this.state.userSaved ? 'Saved' : 'Save' }</span>
			</button>
		)
	}
}

const loadData = ({ report_id, loadLikes, loadSaves }) => {
	loadLikes(report_id)
	loadSaves(report_id)
}

class FeedAttributes extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.report_id !== this.props.report_id) {
			loadData(nextProps)
		}
	}
	
	render() {
		
		const { report_id, likes, saves, commentsCount, user_id, authenticated, onLogin, likeReport, saveReport } = this.props
		
		if (!likes || !saves) {
			return <div></div>
		}
		
		const likesCount = likes.length
		
		const userLiked = likes.indexOf(user_id) > -1 ? true : false
		const userSaved = saves.indexOf(user_id) > -1 ? true : false

		return (
			<div className="attributes">
				<AttrLiked report_id={ report_id } likesCount={ likesCount } userLiked={ userLiked } authenticated={ authenticated } onLogin={ onLogin } likeReport={ likeReport } />
				<button className="attr attr-o attr-hide">
					<span className="icon"><svg viewBox="0 0 576 512"><path d="M576 240c0 115-129 208-288 208-48.3 0-93.9-8.6-133.9-23.8-40.3 31.2-89.8 50.3-142.4 55.7-5.2.6-10.2-2.8-11.5-7.7-1.3-5 2.7-8.1 6.6-11.8 19.3-18.4 42.7-32.8 51.9-94.6C21.9 330.9 0 287.3 0 240 0 125.1 129 32 288 32s288 93.1 288 208z"></path></svg></span><span className="label">{ commentsCount }</span>
				</button>
				<AttrSaved report_id={ report_id } userSaved={ userSaved } authenticated={ authenticated } onLogin={ onLogin } saveReport={ saveReport } />
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.report_id
	const {
		likesById,
		savesById
	} = state
	const likesWrapper = likesById[report_id] || {}
	const savesWrapper = savesById[report_id] || {}
	const likes = likesWrapper.likes
	const saves = savesWrapper.saves
	return {
		report_id: report_id,
		likes,
		saves,
		authenticated: state.auth.authenticated,
		user_id: state.auth.user_id || 0
	}
}

export default withRouter(connect(mapStateToProps, { loadLikes, loadSaves, likeReport, saveReport })(FeedAttributes))


// WEBPACK FOOTER //
// ./src/components/Global/FeedAttributes.js